// http://www.jacklmoore.com/notes/rounding-in-javascript/
function round(value, decimals) {
  return Number(`${Math.round(`${value}e${decimals}`)}e-${decimals}`);
}

export default round;
